import { useApolloClient } from '@apollo/client';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { Redirect } from 'react-router';
import { useObservableCache } from '../../cache/observable-cache-provider';
import { ApplicationConfig } from '../../config/config';
import { useBeaconRouter } from '../../route/route.hooks';
import { runInBackground } from '../../util/async';
import { useDirectConnectHealthGateContext } from './direct-connect-health-gate';

const DirectConnectRegistrationGate = (props: { children: ReactNode }) => {
  const { children } = props;
  const { healthStatus } = useDirectConnectHealthGateContext();

  const { builder } = useBeaconRouter();

  const [redirectToDefaultKioskRoute, setRedirectToDefaultKioskRoute] =
    useState<boolean>(false);

  const client = useApolloClient();
  const observableCache = useObservableCache();

  const kioskRoute = useMemo(() => {
    return builder.getDirectConnectKioskRoute();
  }, [builder]);

  useEffect(() => {
    runInBackground(async () => {
      // if kiosk is disabled then we should not apply this logic
      if (!ApplicationConfig.kiosk.enabled) {
        return false;
      }

      const isRegistered = healthStatus?.isRegistered ?? false;

      // if we are no longer registered then we should clear the cache
      // before redirecting to the default kiosk route which will kick
      // off registration again
      if (!isRegistered) {
        await client.resetStore();
        await observableCache.clear();
      }

      setRedirectToDefaultKioskRoute(!isRegistered);
    });
  }, [healthStatus?.isRegistered, client, observableCache]);

  return (
    <>
      {redirectToDefaultKioskRoute ? (
        <Redirect to={kioskRoute} />
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export { DirectConnectRegistrationGate };
